var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldcupArrowRightDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-double-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00627 8.47798L4.59433 12.3018C4.3585 12.5661 3.97717 12.5661 3.74385 12.3018L3.17687 11.6664C2.94104 11.4021 2.94104 10.9747 3.17687 10.7132L5.59533 8.00281L3.17687 5.29241C2.94104 5.02812 2.94104 4.60075 3.17687 4.33927L3.74134 3.69822C3.97717 3.43393 4.3585 3.43393 4.59182 3.69822L8.00376 7.52202C8.2421 7.78632 8.2421 8.21368 8.00627 8.47798ZM12.8231 7.52202L9.41119 3.69822C9.17536 3.43393 8.79403 3.43393 8.56071 3.69822L7.99373 4.33365C7.7579 4.59794 7.7579 5.0253 7.99373 5.28679L10.4122 7.99719L7.99373 10.7076C7.7579 10.9719 7.7579 11.3993 7.99373 11.6607L8.56071 12.2962C8.79654 12.5604 9.17787 12.5604 9.41119 12.2962L12.8231 8.47235C13.059 8.21368 13.059 7.78632 12.8231 7.52202Z",
    fill: "var(--fill-0, #D9D9D9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldcupArrowRightDisabled);
export default __webpack_public_path__ + "static/media/worldcup-arrow-right-disabled.9a650572785276b82e8072b642c2e7c4.svg";
export { ForwardRef as ReactComponent };